// extracted by mini-css-extract-plugin
module.exports = {"partnershipContainer":"Partnerships_partnershipContainer__mNaNC","logoContainer":"Partnerships_logoContainer__8zQ_G"};